import { render, staticRenderFns } from "./ImplantacoesView.vue?vue&type=template&id=7d3a9d54"
import script from "./ImplantacoesView.vue?vue&type=script&lang=js"
export * from "./ImplantacoesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports